import type { AuthFeature } from '@bixo/ui'
import { useQuery } from '@tanstack/react-query'
import {
  BadgeIndianRupee,
  Boxes,
  Handshake,
  Lock,
  ReceiptText,
  ScanBarcode,
  ShieldCheck,
  Smartphone,
} from 'lucide-react'
import { tenantQuery } from '../lib/api'

/**
 * Brand-panel content for a business's own sign-in pages. White-label: it
 * names the business, never the platform.
 */
export const tenantFeatures: AuthFeature[] = [
  {
    icon: ReceiptText,
    title: 'Billing, POS & estimates',
    text: 'GST invoices, thermal receipts and WhatsApp-ready images.',
  },
  { icon: ScanBarcode, title: 'Scan and sell', text: 'Barcodes from any phone straight into the counter.' },
  { icon: Boxes, title: 'Stock that adds up', text: 'Landed cost, labels and stock across warehouses.' },
  {
    icon: Handshake,
    title: 'Partner network',
    text: 'SIs, referrals and margins earned as invoices get paid.',
  },
  { icon: BadgeIndianRupee, title: 'Ledgers that reconcile', text: 'Outstanding and ageing at a glance.' },
]

export const tenantBadges = [
  { icon: Lock, label: 'Encrypted sessions' },
  { icon: Smartphone, label: 'Two-factor ready' },
  { icon: ShieldCheck, label: 'Audit trail' },
]

export function useTenantBrand() {
  const { data: tenant } = useQuery(tenantQuery)
  const name = tenant?.app_name ?? tenant?.name ?? 'Bixo'
  return { tenant, brand: { name, logoUrl: tenant?.logo_url ?? null } }
}
